import React from "react";
import { WHATSAPP_RDV_URL } from "../../utils/whatsapp";

interface EtapeItem {
  id: number;
  text: string;
}

const etapes: EtapeItem[] = [
  {
    id: 1,
    text: "Nous commençons par écouter votre situation et vos attentes.",
  },
  {
    id: 2,
    text: "Nous échangeons sur votre parcours, vos habitudes et les suivis déjà en cours.",
  },
  {
    id: 3,
    text: "Nous déterminons si un accompagnement proposé par Fouta Bio est adapté.",
  },
  {
    id: 4,
    text: "Nous expliquons les recommandations, les précautions et les prochaines étapes.",
  },
];

const PremiereConsultationSection: React.FC = () => {
  return (
    <section className="premiere-consultation-section">
      <div className="premiere-consultation-container">
        <p className="premiere-consultation-eyebrow mb-3">
          PREMIÈRE CONSULTATION
        </p>

        <h2 className="premiere-consultation-title mb-4">
          Comment se déroule une première consultation ?
        </h2>

        <div className="premiere-consultation-grid">
          {etapes.map((etape) => (
            <div className="premiere-consultation-step" key={etape.id}>
              <span className="premiere-consultation-step-number">
                {etape.id}
              </span>
              <p className="premiere-consultation-step-text">{etape.text}</p>
            </div>
          ))}
        </div>

        <div className="premiere-consultation-note">
          <span className="premiere-consultation-note-icon" aria-hidden="true">
            ℹ️
          </span>
          <p className="premiere-consultation-note-text">
            Une consultation ne commence pas automatiquement par une séance
            de Hijama. Nous cherchons d'abord à comprendre.
          </p>
        </div>

        <div className="premiere-consultation-cta-wrapper">
          <a
            href={WHATSAPP_RDV_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="premiere-consultation-cta"
          >
            Prendre rendez-vous
          </a>
        </div>
      </div>
    </section>
  );
};

export default PremiereConsultationSection;
